import { RatingsSettingsTabName } from '~ratings/Settings/commons/settings-types';

export const SET_CURRENT_SETTINGS_TAB = 'SET_CURRENT_SETTINGS_TAB' as const;
export const setCurrentSettingsTab = (payload?: RatingsSettingsTabName) => ({
  type: SET_CURRENT_SETTINGS_TAB,
  payload,
});
